/**
 * A brick's label, "word → material" (v1 ticket 15): the word in the learner's target language, isolated so its
 * direction never reorders the line, and the material in the interface language. Never a box.
 */
import { html } from 'lit';
import { t } from '../i18n';
import type { Material } from './own-town';

export function brickLabel(word: string, material: Material) {
  const [pre, post = ''] = t('round.brick', { material: t(`round.material.${material}`) }).split('{word}');
  return html`${pre}<bdi class="ca" dir="auto">${word}</bdi>${post}`;
}
